/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Series_LoadingInputs */

const en_us2_body_measures_series_loading = /** @type {(inputs: Body_Measures_Series_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const pt_br2_body_measures_series_loading = /** @type {(inputs: Body_Measures_Series_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando…`)
};

const es_419_body_measures_series_loading = /** @type {(inputs: Body_Measures_Series_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando…`)
};

const pt_pt2_body_measures_series_loading = /** @type {(inputs: Body_Measures_Series_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar…`)
};

const fr_fr2_body_measures_series_loading = /** @type {(inputs: Body_Measures_Series_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const de_de2_body_measures_series_loading = /** @type {(inputs: Body_Measures_Series_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geladen…`)
};

const it_it2_body_measures_series_loading = /** @type {(inputs: Body_Measures_Series_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Body_Measures_Series_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_series_loading = /** @type {((inputs?: Body_Measures_Series_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Series_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_series_loading(inputs)
	if (locale === "es-419") return es_419_body_measures_series_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_series_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_series_loading(inputs)
	if (locale === "de-DE") return de_de2_body_measures_series_loading(inputs)
	if (locale === "it-IT") return it_it2_body_measures_series_loading(inputs)
	return en_us2_body_measures_series_loading(inputs)
});
export { body_measures_series_loading as "body-measures.series_loading" }